import { useEffect } from "react";
import * as Sentry from "@sentry/react";

export const SentryProvider = ({ children }) => {
  useEffect(() => {
    if (window.sentryDsn && !window.location.hostname.includes("localhost")) {
      Sentry.init({
        dsn: window.sentryDsn,
        environment: "production",
        integrations: [Sentry.browserTracingIntegration()],
        tracesSampleRate: 0.1,
        beforeSend(event, hint) {
          const frames = event.exception?.values?.[0]?.stacktrace?.frames || [];

          if (
            frames.some((frame) => frame.filename?.includes("matomo.js") || frame.filename?.includes("intl-tel-input"))
          ) {
            return null;
          }

          return event;
        },

        ignoreErrors: [
          /^Checkout payment error.+$/i,
          /Transaction Declined/i,
          /NotAllowedError/i,
          /The request is not allowed by the user agent/i,
          /Attempting to change value of a readonly property/i,
          /Java object is gone/i,
          /enableDidUserTypeOnKeyboardLogging/i,
          /Network Error/i,
        ],
      });
    }
  }, []);

  return children;
};
